import { render, staticRenderFns } from "./TPS.vue?vue&type=template&id=795b951a&scoped=true&"
import script from "./TPS.vue?vue&type=script&lang=js&"
export * from "./TPS.vue?vue&type=script&lang=js&"
import style0 from "./TPS.vue?vue&type=style&index=0&id=795b951a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b951a",
  null
  
)

export default component.exports